const INFRA_USERS_IDS = [
  '01E5FGQ8YH5MWQZQ38RTHQEY6F',
  '01DGDAM45AB10GZVP8CSFS3PRA',
  '01E84YQDZAAZ4XP2YXHNFJZ5G0',
  '01E87J91EQEX8B3Q0CFEHZQCZH',
  '01E84YT1N59D46SW26DKMBEDWP',
  '01E84YWWAKSRDGX47139KQ7QQR',
  '01JHND9V2AR1A0M4KESVCESB0B',
]

export default INFRA_USERS_IDS
